import { flatJoin } from "shared/util"
import { ListItem, ListItemButton, ListItemProps, Stack, Typography } from "@mui/material"
import { KojinOrgan } from "interface/kojin"

type OrganListItemProps = {
  organ: KojinOrgan
  onSisetuOpen: (sisetuCode: string) => void
} & ListItemProps
export const OrganListItem = ({
  organ,
  onSisetuOpen,
  ...others
}: OrganListItemProps) => {
  return (
    <ListItem disablePadding {...others}>
      <ListItemButton
        onClick={() => onSisetuOpen(organ.sisetuCode)}
        sx={{
          padding: 1
        }}
      >
        <Stack direction="column" width='100%'>
          <Stack direction="row" paddingX={1} justifyContent="flex-start" alignItems="baseline" flexWrap="wrap">
            <Typography component="span" variant="body2" color="text.primary">{organ.sisetuName}</Typography>
            {(organ.keieitai?.name || organ.bedCount) ? (
              <Typography variant="caption" color="text.secondary">（{
                flatJoin(' ', organ.keieitai?.name, organ.bedCount ? `${organ.bedCount}床` : null)
              }）</Typography>
            ) : <></>}
          </Stack>
          <Typography variant="caption" color="text.secondary" borderTop='1px solid #dcdcdc' paddingX={1}>
            {flatJoin(' ',
              organ.bukaName,
              (organ.bukaHojoName && organ.bukaHojoName !== organ.bukaName) ? `（${organ.bukaHojoName}）` : null,
              organ.yakusyokuName
            )}
          </Typography>
        </Stack>
      </ListItemButton>
    </ListItem>
  )  
}
